import React from 'react';
import { Alert, Button } from '@mui/material';

interface Props {
  what: string;
  onRetry: () => void;
}

/** Shown over a list when a direct link's item could not be read for a reason that is not "not found". */
export const PermalinkLoadFailed: React.FC<Props> = ({ what, onRetry }) => (
  <Alert
    severity="error"
    sx={{ mb: 2 }}
    role="alert"
    action={
      <Button color="inherit" size="small" onClick={onRetry}>
        Try again
      </Button>
    }
  >
    That {what} could not be loaded.
  </Alert>
);
